<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Resit Kaunter">

            <w-flex justify-space-between class="mb4">
                <div class="xs4">
                    <z-input 
                          label="Tarikh Dari" 
                          name="tarikh_dari" 
                          v-model="cari.tarikh_dari" 
                           type="date"/>
                </div>
                 <div class="xs4"> 
                    <z-input 
                          label="Tarikh hingga *" 
                          name="tarikh_hingga" 
                          v-model="cari.tarikh_hingga"
                           type="date"/>
                </div>
                <div class="xs4">
                    <z-lookup label="Status" name="status" :url='service_utiliti+"lookup/resit_status"' :sort="false" :cache="false" v-model="cari.lkp_resit_status_id" /> 
                </div>
            </w-flex>

            
            <w-flex justify-space-between class="mb4">
                <div class="xs4">
                    <!-- <z-lookup label="Nama" name="profil" :url='service_utiliti+"lookup/profil"' :sort="false" :cache="false" v-model="cari.profil_id" />  -->
                    <w-input v-model="cari.nama_id" label="Nama" /> 

                </div>
                
                 <div class="xs4"> 
                    <w-input v-model="cari.no_resit" label="No. Resit " /> 
                </div>
                 <div class="xs4">
                    <w-input v-model="cari.user_id" label="Pegawai Kaunter " />  
                 </div>
            </w-flex>

             <w-flex justify-space-between class="mb4">
                <div class="xs4">
                     <z-lookup :url="service_utiliti +'lookup/cara_bayar_kaunter'"
                    :sort="false"
                    :cache="false"
                    v-model="cari.lkp_cara_bayaran_id"
                    label="Cara Bayaran "
                />
                </div>
                <div class="xs4">
                    <w-input v-model="cari.no_dokumen" label="No. Cek/Bank Draf/Transaksi Bank" /> </div>
                <div class="xs4">
                    <z-lookup
                      label="Terimaan Tanpa Bil"
                      :options="manual"
                      v-model="cari.is_manual"
                      :sort="false"
                      :cache="false"
                    />
                </div>
            </w-flex>
            <w-flex justify-space-between class="mb4">
                <div class="xs4">
                     <z-lookup :url="service_kutipan +'lookup/jabatan_baharu'"
                    :sort="false"
                    :cache="false"
                    v-model="cari.jabatan_id"
                    label="jabatan"
                />
                </div>
                
            </w-flex>
                                        

            <div class="mt2 text-right">
                <!--  <w-button bg-color="success" class="mr3" @click="cetakSenarai">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak Senarai
                </w-button> -->
                <w-button class="ml1" v-on:click="reset()" :loading="cari.loading" bg-color="warning">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="carian()" :loading="cari.loading">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
            <br>

             <div class="mt2 text-right">
                 <w-button bg-color="success" class="mr3" @click="cetakSenarai">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak Senarai
                </w-button>
                <w-button bg-color="success" class="mr3" @click="cetak">
                    <w-icon>fal fa-print</w-icon>
                    &nbsp;Cetak Salinan
                </w-button>
                <w-button bg-color="success" class="mr3" @click="cetak_pejabat">
                    <w-icon>fal fa-print</w-icon>
                    &nbsp;Cetak Salinan Pejabat
                </w-button>
             </div>
            <br>

            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
            <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>

            <z-table ref="tbluser" title="Senarai : Resit Kaunter" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        <!-- <w-button bg-color="success" class="mr3" @click="cetak">
                            <w-icon>fal fa-print</w-icon>
                            Cetak Salinan
                        </w-button>
                        <br>
                        <w-button bg-color="success" class="mr3" @click="cetak_pejabat">
                            <w-icon>fal fa-print</w-icon>
                            Cetak Salinan Pejabat
                        </w-button>
                        <br> -->
                        &nbsp;
                        <w-checkbox v-model="pilih" @click="cekPilih"></w-checkbox>
                    </template>


                    <template v-else>
                         {{ label }}
                    </template>
                </template>

                 <!-- <template v-if="$zutil.can('Hq Pelulus Batal Resit')"> -->
                <template #item-cell.jabatan="{ item, label, header, index }">
                    {{item.jabatan}} 
                </template>
            <!-- </template> -->
               <!--  <template #item-cell.kaunter="{ item, label, header, index }">
                    {{item.user}} 
                </template> -->
               <template #item-cell.profil="{ item, label, header, index }">
                    {{item.no_id}} | {{item.profil}} 
                </template>
                <template #item-cell.amaun="{ item, label, header, index }">
                    {{$zutil.currency(item.amaun)}}
                </template>


                <template #item-cell.action="{ item, label, header, index }">
                  <w-flex class="flex justify-center">
                    <inertia-link :href='$route("kutipan.resit.show",item.id)'>
                        <w-tooltip top>
                           <template #activator="{ on }">
                             <w-icon v-on="on" >
                               fal fa-file
                             </w-icon>
                           </template>
                           Papar
                         </w-tooltip>
                        </inertia-link>&nbsp;&nbsp;
                        <template v-if="item.is_manual == null">
                             <w-checkbox v-model="item.pilih"></w-checkbox>
                        </template>
                  </w-flex>
                </template>

            </z-table>
            <w-flex class="mt3" wrap align-center justify-end>
               <!--  <w-button bg-color="success" class="mr3" @click="cetak">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                </w-button> -->
                <!-- &nbsp;&nbsp; -->
                <!-- <w-button bg-color="success" class="mr3" @click="SenaraiCetakan()">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak Senarai
                </w-button> -->
               
                 
            </w-flex>

        </z-page>
        <!-- <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Cetak Senarai
            </template>

             <w-flex justify-space-between class="mb4">
                <div class="xs4">
                    <z-input 
                          label="Tarikh Dari" 
                          name="tarikh_dari" 
                          v-model="cari.tarikh_dari" 
                           type="date"/>
                </div>
                 <div class="xs4"> 
                    <z-input 
                          label="Tarikh hingga *" 
                          name="tarikh_hingga" 
                          v-model="cari.tarikh_hingga"
                           type="date"/>
                </div>
                 <div class="xs4"> 
                 </div>
            </w-flex>
            

            <template #actions>
                <div class="spacer" />
                <w-button bg-color="success" class="mr3" @click="cetakSenarai">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                </w-button>
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog> -->
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_kutipan +'resit',
        loading : true,
        reload: true,
        resit_id : null,
        cari : {
          loading: false,
        },
        dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
            },
            manual: [
                {
                    value: null,
                    label: "AUTO",
                },
                {
                    value: 1,
                    label: "MANUAL"
                }
            ],
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Resit Kaunter', route: '/resit' },
            { label: 'Senarai', route: '/resit' }
          ],
          cari : {nama_id:'', no_resit:'', tarikh_dari:'', tarikh_hingga: '', lkp_resit_status_id: '', user_id: '', lkp_cara_bayaran_id: '', no_dokumen: '', is_manual: '', jabatan_id: ''},

          pilih : false
        }
         
  },
  methods: {

    carian() {
      this.cari.loading = true
             this.$inertia.visit(window.route('kutipan.resit.index')+'?nama_id='+this.cari.nama_id+'&no_resit='+this.cari.no_resit+'&tarikh_dari='+this.cari.tarikh_dari+'&tarikh_hingga='+this.cari.tarikh_hingga+'&lkp_resit_status_id='+this.cari.lkp_resit_status_id+'&user_id='+this.cari.user_id+'&lkp_cara_bayaran_id='+this.cari.lkp_cara_bayaran_id+'&no_dokumen='+this.cari.no_dokumen+'&is_manual='+this.cari.is_manual+'&jabatan_id='+this.cari.jabatan_id , {preserveScroll:true})
             .finally(() => {
                      
                     this.cari.loading = false;

                  });
    
            
        },
        reset(){
              this.cari = {nama_id:'', no_resit:'', tarikh_dari:'', tarikh_hingga: '', lkp_resit_status_id: '', user_id: '', lkp_cara_bayaran_id: '', no_dokumen: '', is_manual: '', jabatan_id: ''}
              // this.carian()

              this.$inertia.visit(window.route('kutipan.resit.index') , {preserveScroll:true})

            // this.$inertia.visit(this.$route('kutipan.resit.index'))
        },

        cekPilih(){
        
        for (var i in this.table.items) {
            // alert(this.table.items[i].is_manual)
            if (this.table.items[i].is_manual == null) {
                this.table.items[i].pilih = this.pilih;
            }
        }
      },

      search() {
      var url = window.route('kutipan.resit.index')+'?resit_id='+this.resit_id;
      this.$inertia.visit(url, { preserveScroll : true})
    },

      cetak() {
        var id = '';
        for (var i in this.table.items) {
            if(this.table.items[i].pilih == true){
                id = this.table.items[i].id+','+id
            }
        }
        if(id)

            // window.location.href = this.service_kutipan+'resit/cetak/'+id;
            {window.open(this.service_kutipan + 'resit/cetak/' + id, '_blank');
        }else if(this.table.items[i].is_manual != null){
            alert('Resit Manual Tidak Boleh Cetak.')
        }else{
            alert('sila pilih dulu.')
        }
      },

      cetak_pejabat() {
        var id = '';
        for (var i in this.table.items) {
            if(this.table.items[i].pilih == true){
                id = this.table.items[i].id+','+id
            }
        }
        if(id){
            // window.location.href = this.service_kutipan+'resit/cetak/'+id+'?pejabat='+1;
            window.open(this.service_kutipan + 'resit/cetak/' + id + '?pejabat=1', '_blank');
        }else if(this.table.items[i].is_manual != null){
            alert('Resit Manual Tidak Boleh Cetak.')
        }else{
            alert('sila pilih dulu.')
        }
      },

       cetakSenarai() {
               
                 // window.location.href = this.service_kutipan+'resit/cetaksenarai/'+'cetak'+'?nama_id='+this.cari.nama_id+'&no_resit='+this.cari.no_resit+'&tarikh_dari='+this.cari.tarikh_dari+'&tarikh_hingga='+this.cari.tarikh_hingga+'&lkp_resit_status_id='+this.cari.lkp_resit_status_id+'&jabatan_id='+this.cari.jabatan_id+'&user_auth='+this.$page.props.auth.user.id+'&lkp_cara_bayaran_id='+this.cari.lkp_cara_bayaran_id+'&no_dokumen='+this.cari.no_dokumen, {preserveScroll:true};
                window.open(
                    this.service_kutipan +
                    'resit/cetaksenarai/cetak' +
                    '?nama_id=' + this.cari.nama_id +
                    '&no_resit=' + this.cari.no_resit +
                    '&tarikh_dari=' + this.cari.tarikh_dari +
                    '&tarikh_hingga=' + this.cari.tarikh_hingga +
                    '&lkp_resit_status_id=' + this.cari.lkp_resit_status_id +
                    '&jabatan_id=' + this.cari.jabatan_id +
                    '&user_auth=' + this.$page.props.auth.user.id +
                    '&lkp_cara_bayaran_id=' + this.cari.lkp_cara_bayaran_id +
                    '&no_dokumen=' + this.cari.no_dokumen,
                    '_blank'
                );
                
            // window.location.href = this.service_kutipan+'resit/senarai/';
        },
        SenaraiCetakan() {
            this.dialog.show = 1;
        },
        


  },
  watch: {
     
  },
  mounted() {
    // override default setting
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.resit_id){
        this.resit_id = this.cari.resit_id
        // this.search();
    }
    if(this.cari && this.cari.no_resit && this.cari.no_resit == 'undefined'){
      this.cari.no_resit = ''
    }
    if(this.cari && this.cari.no_dokumen && this.cari.no_dokumen == 'undefined'){
      this.cari.no_dokumen = ''
    }
    if(this.cari && this.cari.user_id && this.cari.user_id == 'undefined'){
      this.cari.user_id = ''
    }
    if(this.cari && this.cari.nama_id && this.cari.nama_id == 'undefined'){
      this.cari.nama_id = ''
    }
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>